import {
  IconCalendar,
  IconCog,
  IconError,
  IconFilter,
  IconLocation,
  IconMinus,
  IconPlus,
} from "./icons";
import tailwindTheme from "../tailwind.theme";
import PropTypes from "prop-types";
import classNames from "classnames";
import AvatarCircle from "./basic/AvatarCircle";
import { useState } from "react";
import { Small } from "./basic/Text";
import { ImageDownload } from "./ImageUpload";
// Local Helpers

export const Label = ({ children }) => {
  return <>{children ? <p className="pb-2 font-bold">{children}</p> : null}</>;
};

export const InputTextUncontrolled = ({
  placeholder = "",
  errorMessage = "",
  inputref = null,
}) => {
  const [inputText, setInputText] = useState("");
  const css = {
    container: "flex flex-row items-center rounded-lg border-2 p-1",
    inputbase: "h-10 text-primary-dark-100 border-0 flex-grow",
    base: " w-full px-4 py-4 ",
    normal: "border-gray",
    error: "border-tertiary-secondary-100",
  };
  const handleChange = (event) => {
    setInputText(event.target.value);
  };
  return (
    <div
      className={classNames(
        css.container,
        errorMessage == "" ? css.normal : css.error
      )}
    >
      <input
        type="text"
        placeholder={placeholder}
        onChange={handleChange}
        ref={inputref}
        className={classNames(css.inputbase)}
      />
      {errorMessage ? <IconError /> : <></>}
    </div>
  );
};

export const InputText = ({
  id = "",
  placeholder,
  errorMessage = "",
  formRegistry,
  showErrors = true,
  className = "",
  onKeyUp
}) => {
  const css = {
    base: "h-11 w-full px-4 py-4 text-primary-dark-100 rounded-lg",
    normal: "border-gray",
    error: "border-tertiary-secondary-100",
  };

  return (
    <div>
      <input
        id={id}
        {...formRegistry}
        type="text"
        placeholder={placeholder}
        className={classNames(
          css.base,
          errorMessage == "" ? css.normal : css.error,
          className
        )}
        onKeyUp={onKeyUp}
      />
      {showErrors ? (
        <p className="pt-1 mb-2 text-sm text-tertiary-secondary-100">
          {errorMessage}
        </p>
      ) : (
        <></>
      )}
    </div>
  );
};

InputText.propTypes = {
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  formRegistry: PropTypes.object,
  showErrors: PropTypes.bool,
};


export const InputBasic = ({
  onChange = false,
  label = "",
  errorMessage,
  icon,
  placeholder,
  className = "",
}) => {
  return (
    <div>
      {label && (
        <p className="inline-block font-bold">
          {label} &nbsp;{icon}
        </p>
      )}
      <input
        placeholder={placeholder}
        onChange={onChange}
        errorMessage={errorMessage}
        className={className}
      />
    </div>
  );
};

export const Input = ({
  formRegistry,
  label = "",
  errorMessage,
  icon,
  placeholder,
  className = "",
  onKeyUp
}) => {
  return (
    <div>
      {label && (
        <p className="inline-block pb-2 font-bold">
          {label} &nbsp;{icon}
        </p>
      )}
      <InputText
        placeholder={placeholder}
        formRegistry={formRegistry}
        errorMessage={errorMessage}
        className={className}
        onKeyUp={onKeyUp}
      />
    </div>
  );
};

export const InputFile = ({
  formRegistry,
  label = "Upload File",
  onChangeHandler,
  id = "formFile",
  sublabel = "",
}) => {

  return (
    <div className="">
      <label
        htmlFor={id}
        className="relative flex items-center justify-center block text-sm text-center text-white uppercase rounded-lg w-72 h-11 bg-primary-100 hover:cursor-pointer hover:bg-primary-50"
      >
        <span>{label}</span>
        <span className="absolute right-0 mr-3">
          <IconPlus />
        </span>
      </label>
      {sublabel && (
        <Small className="pt-2 text-center text-primary-100">{sublabel}</Small>
      )}
      <input
        {...formRegistry}
        onChange={onChangeHandler}
        className="hidden"
        type="file"
        id={id}
      />
    </div>
  );
};

// Text Areas

export const Textarea = ({
  formRegistry,
  label = "",
  errorMessage = "",
  icon,
  children,
  className = "",
}) => {
  const theme = {
    base: "h-11 w-full px-6 py-4 text-black rounded-lg ",
    normal: "border-gray",
    error: "border-tertiary-secondary-100",
    label: "inline-block pb-2 font-bold",
    errormsg: "pt-4 text-sm text-tertiary-secondary-100",
  };

  const css = classNames(
    theme.base,
    errorMessage == "" ? theme.normal : theme.error,
    className
  );

  return (
    <>
      {label ? (
        <>
          <p className={theme.label}>
            {label} &nbsp; {icon}
          </p>
        </>
      ) : null}
      <textarea {...formRegistry} className={css} rows={10}>
        {children}
      </textarea>
      {errorMessage ? <p className={theme.errormsg}>{errorMessage}</p> : null}
    </>
  );
};

// Datepicker
export const InputDatepicker = ({
  label,
  formRegistry,
  errorMessage,
  icon,
}) => {
  return (
    <>
    <p className="inline-block pb-2 font-bold">{label}</p>
    <div className="flex w-full rounded-lg">
      <div className="flex items-center justify-center p-2 rounded-l-md bg-primary-100">
        <IconCalendar />
      </div>
      <input
        {...formRegistry}
        type="datetime-local"
        className="w-full px-6 py-4 text-center text-black rounded-r border-gray"
      />
      {errorMessage && (
        <p className="flex items-center ml-4 text-sm text-tertiary-secondary-100">
          {errorMessage}
        </p>
      )}
    </div>

    </>
  );
};

export const InputChooseDateTime = ({
  className='',
  onChange=false,
}) => {

  return (
    <div className="flex w-full md:w-48 rounded-lg">
      <div className="flex items-center justify-center p-2 rounded-l h-12 w-9 bg-primary-100">
        <IconCalendar />
      </div>
      <input
        type="datetime-local"
        className={`w-full pl-2 text-xs rounded-r ${className}`}
        onChange={onChange}
      />
    </div>
  );
};

export const InputChooseDateFilter = () => {
  return (
    <div className="flex w-full md:w-48 rounded-lg">
      <div className="flex items-center justify-center p-2 rounded-l h-9 w-9 bg-primary-100">
        <IconCalendar />
      </div>
      <input
        type="date"
        className="w-full pl-2 text-xs text-white rounded-r h-9 border-misc-darkblue bg-primary-dark-100"
      />
    </div>
  );
};

export const InputReadOnlyLocation = ({ location }) => {
  return (
    <div className="flex w-full md:w-48 rounded-lg">
      <div className="flex items-center justify-center p-2 rounded-l h-9 w-9 bg-primary-100">
        <IconLocation />
      </div>
      <input
        type="text"
        readOnly
        placeholder={location}
        className="w-full pl-2 text-xs text-white rounded-r h-9 border-misc-darkblue bg-primary-dark-100 placeholder:text-white"
      />
    </div>
  );
};

export const InputOpenFilters = ({ open, onToggleFilterMenu }) => {

  return (
    <div onClick={onToggleFilterMenu} className="relative flex w-full md:w-48 border rounded-lg border-misc-darkblue">
      <div className="flex items-center justify-center p-2 rounded-l h-9 w-9 bg-primary-100">
        <IconFilter />
      </div>
      <input
        type="text"
        readOnly
        placeholder="Filter results"
        className="w-full pl-2 text-xs text-white border-none h-9 bg-primary-dark-100 placeholder:text-white"
      />
      <button type="button">
        <div className="flex items-center justify-center p-2 border-l h-9 w-9 border-misc-darkblue">
          {open ? <IconMinus/> : <IconPlus />}
        </div>
      </button>

    </div>
  );

};

export const Checkbox = ({
  id,
  label,
  checked,
  formRegistry,
  onChange,
  value = "true",
}) => {
  return (
    <>
      <input
        id={id}
        type="checkbox"
        className="mr-4 rounded-sm border-gray checked:bg-primary-100"
        checked={checked ? true : false}
        onChange={() => {
          onChange;
        }}
        {...formRegistry}
      />
      {label}
    </>
  );
};

export const CheckboxWithSettings = ({
  id,
  label,
  checked,
  formRegistry,
  formRegistry2,
  settingsClick,
}) => {
  return (
    <>
      <div className="flex items-center justify-between w-full h-12 border-b-0 border-lightwhite">
        <div>
          <input
            id={id}
            type="checkbox"
            className="w-4 h-4 m-3 rounded-sm xwaccent-red-800 checked:bg-primary-100 focus:bg-lightwhite"
            // {...(checked ? "checked" : ""}
            // onClick={onChange}
            {...formRegistry}
          />
          <span className="flex-grow pl-5">{label}</span>
        </div>
        {/* <Button clickFunction={settingsClick}>Edit</Button> */}
        <span onClick={settingsClick}>
          <IconCog fill={tailwindTheme["primary-dark"][100]} />
        </span>
      </div>
    </>
  );
};

// Select
export const Select = ({
  options = [],
  label,
  className = "w-full px-6 py-4 text-black rounded-lg border-gray",
  formRegistry,
  onChange= false,
}) => {
  return (
    <>
      {label ? <Label>{label}</Label> : <></>}
      <select className={classNames(className)} {...formRegistry} onChange={onChange}>
        {options.map((item, idx) => (
          <option
            key={idx}
            value={item.value}
            // {...(v == 0 ? "disabled selected hidden" : "")}
          >
            {item.label}
          </option>
        ))}
      </select>
    </>
  );
};

export const AssignConsultantSelect = ({
  consultants,
  formRegistry,
  accessToken,
  errorMessage,
  getValues,
}) => {
  const findConsultant = (id) => {
    const find = consultants.filter((obj) => obj.id == id);
    if (find.length == 1) {
      return find[0];
    } else {
      return { avatar_id: null, given_name: null, family_name: null };
    }
  }

  const [currentConsultant, SetCurrentConsultant] = useState(findConsultant(getValues('consultant_id')))

  // kxLog('currentConsultant', currentConsultant)

  const handleChange = (event) => {
    const consultant = SetCurrentConsultant(findConsultant(event.target.value));
  };

  const getInitials = () => {
    if (!currentConsultant.avatar_id) {
      return "N/A";
    }
    return currentConsultant?.given_name != ""
      ? `${currentConsultant?.given_name.charAt(
          0
        )}${currentConsultant?.family_name.charAt(0)}`
      : "N/A";
  };

  return (
    <div className="flex items-center">
      <div className="flex-grow-0 mr-3">
        <ImageDownload
          accessToken={accessToken}
          id={currentConsultant?.avatar_id}
          className="object-cover w-12 h-12 rounded-full"
          altPlaceholder={<AvatarCircle text={getInitials()} />}
        />
      </div>
      <div className="flex-1">
        <select
          className="w-full px-6 text-black rounded-lg h-11 border-gray"
          {...formRegistry}
          onChange={handleChange}
        >
          <option key={999} value={0}>
            No consultant
          </option>
          {consultants.map((consultant, idx) => (
            <option key={idx} value={consultant.id}>
              {consultant.family_name} {consultant.given_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
AssignConsultantSelect.propTypes = {
  consultants: PropTypes.array,
};
